import { render, staticRenderFns } from "./ImgFallback2.vue?vue&type=template&id=7ef65d00&"
import script from "./ImgFallback2.vue?vue&type=script&lang=js&"
export * from "./ImgFallback2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7ef65d00')) {
      api.createRecord('7ef65d00', component.options)
    } else {
      api.reload('7ef65d00', component.options)
    }
    module.hot.accept("./ImgFallback2.vue?vue&type=template&id=7ef65d00&", function () {
      api.rerender('7ef65d00', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-20obWn0Xya0Tn/JS/comp/ImgFallback2.vue"
export default component.exports